export default __webpack_public_path__ + "static/media/hero.8df60867.png";